import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["meta", "icon", "avatar"];
//
// Copyright IBM Corp. 2022
//
// This source code is licensed under the Apache-2.0 license found in the
// LICENSE file in the root directory of this source tree.
//
import React from 'react';
import { Tag, Accordion, AccordionItem } from 'carbon-components-react';
import PropTypes from 'prop-types';
import { NoDataEmptyState } from '../../components/EmptyStates/NoDataEmptyState';
import { pkg } from '../../settings';
import { AddSelectMetaPanel } from './AddSelectMetaPanel';
var blockClass = "".concat(pkg.prefix, "--add-select__sidebar");
var componentName = 'AddSelectSidebar';
export var AddSelectSidebar = function AddSelectSidebar(_ref) {
  var _modifiers$options;

  var appliedModifiers = _ref.appliedModifiers,
      closeIconDescription = _ref.closeIconDescription,
      displayMetalPanel = _ref.displayMetalPanel,
      influencerTitle = _ref.influencerTitle,
      items = _ref.items,
      metaPanelTitle = _ref.metaPanelTitle,
      modifiers = _ref.modifiers,
      multiSelection = _ref.multiSelection,
      noSelectionDescription = _ref.noSelectionDescription,
      noSelectionTitle = _ref.noSelectionTitle,
      setDisplayMetaPanel = _ref.setDisplayMetaPanel;
  var hasModifiers = (modifiers === null || modifiers === void 0 ? void 0 : (_modifiers$options = modifiers.options) === null || _modifiers$options === void 0 ? void 0 : _modifiers$options.length) > 0;
  var hasSelections = multiSelection.length > 0;

  var getNewItem = function getNewItem(item) {
    // certain properties should not be displayed in the sidebar
    // eslint-disable-next-line no-unused-vars
    var meta = item.meta,
        icon = item.icon,
        avatar = item.avatar,
        newItem = _objectWithoutProperties(item, _excluded);

    return newItem;
  };

  var sidebarItems = multiSelection.map(function (selectionId) {
    if (Array.isArray(items)) {
      var selectedItem = items.find(function (item) {
        return item.id === selectionId;
      });
      return getNewItem(selectedItem);
    }

    return getNewItem(items[selectionId]);
  });

  var getTitle = function getTitle(item) {
    return /*#__PURE__*/React.createElement("div", {
      className: "".concat(blockClass, "-accordion-title")
    }, /*#__PURE__*/React.createElement("div", {
      className: "".concat(blockClass, "-selected-item")
    }, /*#__PURE__*/React.createElement("p", {
      className: "".concat(blockClass, "-selected-item-title")
    }, item.title), /*#__PURE__*/React.createElement("p", {
      className: "".concat(blockClass, "-selected-item-subtitle")
    }, item.subtitle)), hasModifiers && /*#__PURE__*/React.createElement("div", null, appliedModifiers.find(function (modifier) {
      return modifier.id === item.id;
    })[modifiers.id]));
  };

  if (Object.keys(displayMetalPanel).length !== 0) {
    return /*#__PURE__*/React.createElement(AddSelectMetaPanel, {
      closeIconDescription: closeIconDescription,
      meta: displayMetalPanel.meta,
      setDisplayMetaPanel: setDisplayMetaPanel,
      title: metaPanelTitle
    });
  }

  return /*#__PURE__*/React.createElement("div", {
    className: blockClass
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(blockClass, "-header")
  }, /*#__PURE__*/React.createElement("p", {
    className: "".concat(blockClass, "-title")
  }, influencerTitle), /*#__PURE__*/React.createElement(Tag, {
    type: "gray",
    size: "sm"
  }, multiSelection.length)), hasSelections ? /*#__PURE__*/React.createElement(Accordion, {
    align: "start"
  }, sidebarItems.map(function (item) {
    return /*#__PURE__*/React.createElement(AccordionItem, {
      title: getTitle(item),
      key: item.id
    }, Object.keys(item).map(function (key) {
      return /*#__PURE__*/React.createElement("div", {
        className: "".concat(blockClass, "-item"),
        key: key
      }, /*#__PURE__*/React.createElement("p", {
        className: "".concat(blockClass, "-item-header")
      }, key), /*#__PURE__*/React.createElement("p", {
        className: "".concat(blockClass, "-item-body")
      }, item[key]));
    }));
  })) : /*#__PURE__*/React.createElement("div", {
    className: "".concat(blockClass, "-body")
  }, /*#__PURE__*/React.createElement(NoDataEmptyState, {
    subtitle: noSelectionDescription,
    title: noSelectionTitle,
    size: "sm"
  })));
};
AddSelectSidebar.propTypes = {
  appliedModifiers: PropTypes.array,
  closeIconDescription: PropTypes.string,
  displayMetalPanel: PropTypes.object,
  influencerTitle: PropTypes.string,
  items: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  metaPanelTitle: PropTypes.string,
  modifiers: PropTypes.object,
  multiSelection: PropTypes.array,
  noSelectionDescription: PropTypes.string,
  noSelectionTitle: PropTypes.string,
  setDisplayMetaPanel: PropTypes.func
};
AddSelectSidebar.displayName = componentName;